var React = require('react');

function IconStaticCircleO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M511.9 65.2c247.5 0 448 200.6 448 448 0 247.5-200.5 448-448 448s-448-200.5-448-448 200.5-448 448-448zm0 831.6c211.8 0 383.6-171.6 383.6-383.6 0-211.8-171.8-383.6-383.6-383.6S128.3 301.4 128.3 513.2s171.8 383.6 383.6 383.6zm1.5-124.3c-142.1 0-257.2-115.1-257.2-257s115.2-257 257.2-257 257.2 115.1 257.2 257-115.1 257-257.2 257z"}));
}

IconStaticCircleO.displayName = "IconStaticCircleO";

IconStaticCircleO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconStaticCircleO;

IconStaticCircleO.default = IconStaticCircleO;
